import React from 'react';

import styles from 'prototypes/securedCard/app.module.scss';
import { CASHBACK_LABEL, SAVINGS_APY_LABEL } from 'prototypes/securedCard/prototypeAssumptions';

const RateChips = () => (
  <div className={styles.chipRow}>
    <span className={styles.chip}>
      <span className={styles.chipStrong}>{SAVINGS_APY_LABEL}</span>
      On your savings
    </span>
    <span className={styles.chip}>
      <span className={styles.chipStrong}>{CASHBACK_LABEL}</span>
      Typical flat rate
    </span>
  </div>
);

export default RateChips;
